/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateV2ExecuteResponse {
    getFixupPrototypeFunction() { return TemplateV2ExecuteResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateV2ExecuteResponse>): TemplateV2ExecuteResponse {
        let obj = Object.assign(new TemplateV2ExecuteResponse(), model);
        TemplateV2ExecuteResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateV2ExecuteResponse>): TemplateV2ExecuteResponse {
        if (!model) return null;
        return TemplateV2ExecuteResponse.newInstance(<TemplateV2ExecuteResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateV2ExecuteResponse) {
        if (!obj) return;

        models.TemplateV2ExecuteResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateV2ExecuteResponse): boolean {
        Object.setPrototypeOf(obj, TemplateV2ExecuteResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique ID of the created job
     */
    job_id: string;

}
